import {
  ApplicationConfig,
  provideAppInitializer,
  inject,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  AppEnvironment,
  provideSignalrNotifications,
} from 'sham-components/services';
import {
  TranslateLoader,
  TranslateModule,
  TranslationObject,
  TranslateService,
} from '@ngx-translate/core';
import { firstValueFrom, Observable } from 'rxjs';

import { routes } from './app.routes';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';
import { API_BASE_URL } from '@/environments/environment';
import { authInterceptor } from './services/auth.interceptor';
import { SigninManager } from 'sham-components/shared/auth';
import { appEnvFactory } from '@/app/services/appEnvFactory';
import { AuthService } from './services/auth.service';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}
  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}

export function httpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // provideSignalrNotifications({
    //   hubUrl: `${API_BASE_URL}/hubs/notifications`,
    //   accessTokenFactory: () => sessionStorage.getItem('accessToken') ?? '',
    //   notificationEventNames: ['NotificationReceived'],
    //   enableAutomaticReconnect: true,
    // }),

    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(() => {
      const appEnv = inject(AppEnvironment);
      const authService = inject(AuthService);
      const dashboardService = inject(ShamDashboardData);
      const translationService = inject(TranslateService);

      return appEnvFactory(appEnv).then(() =>
        Promise.allSettled([
          firstValueFrom(authService.processRefreshVerification()),
          dashboardLayoutDataFactory(dashboardService, translationService),
        ]),
      );
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
